module.exports = __webpack_public_path__ + "img/collection-weddingRingsRingSets@2x.5c0ff33.jpg";